import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Footer from "./footer";
import { Responsive, Container, Grid, Image, Divider } from 'semantic-ui-react';
import BoardItem from "./boarditem";
class MemberList extends Component {
  state={
    memberlist:[
      {
        "firstname": "Ada",
        "lastname": "WONG",
        "presidency": "",
        "classification": "Private Banking",
        "year": 2011
      },
      {
        "firstname": "Alex",
        "lastname": "LAU",
        "presidency": "President\n2020-2021",
        "classification": "Investment Banking",
        "year": 2014
      },
      {
        "firstname": "Alex",
        "lastname": "TSANG",
        "presidency": "",
        "classification": "Interior Design",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Bonnie",
        "lastname": "WONG",
        "presidency": "",
        "classification": "Asset Management",
        "year": 2015
      },
      {
        "firstname": "Constant",
        "lastname": "MO",
        "presidency": "",
        "classification": "Accountant",
        "year": 2019
      },
      {
        "firstname": "Daniel",
        "lastname": "LO",
        "presidency": "President 2011-2012",
        "classification": "Food & Beverage",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Derek",
        "lastname": "CHEUNG",
        "presidency": "",
        "classification": "Wealth Management",
        "year": "2018"
      },
      {
        "firstname": "Edmond",
        "lastname": "CHAN",
        "presidency": "President\n2021-2022",
        "classification": "Construction Industry",
        "year": 2015
      },
      {
        "firstname": "Elsie",
        "lastname": "GUNG",
        "presidency": "President 2018-2019",
        "classification": "Retail Banking",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Eric",
        "lastname": "LUI",
        "presidency": "",
        "classification": "Medical - Physiotherapy",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Fonia",
        "lastname": "WONG",
        "presidency": "Charter President 2009-2010",
        "classification": "Wealth Management",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Harriet",
        "lastname": "LI",
        "presidency": "",
        "classification": "Medical Laboratory Technology",
        "year": "2021"
      },
      {
        "firstname": "Henry",
        "lastname": "HO",
        "presidency": "President 2016-2017",
        "classification": "Business Aviation",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Inez",
        "lastname": "WU",
        "presidency": "",
        "classification": "Biomedical & Health Technology",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Jenny",
        "lastname": "LEE",
        "presidency": "",
        "classification": "Music Education",
        "year": 2018
      },
      {
        "firstname": "Jessica",
        "lastname": "WONG",
        "presidency": "",
        "classification": "Psychiatrist",
        "year": "2022"
      },
      {
        "firstname": "Joey",
        "lastname": "CHAN",
        "presidency": "",
        "classification": "Law",
        "year": "2022"
      },
      {
        "firstname": "Karen",
        "lastname": "CHAN",
        "presidency": "President 2015-2016",
        "classification": "Corporate Finance",
        "year": 2011
      },
      {
        "firstname": "Kenny",
        "lastname": "LEE",
        "presidency": "President 2017-2018",
        "classification": "Wealth Management",
        "year": 2012
      },
      {
        "firstname": "Kent",
        "lastname": "LI",
        "presidency": "",
        "classification": "Civil Engineer",
        "year": 2012
      },
      {
        "firstname": "Mavis",
        "lastname": "CHAN",
        "presidency": "",
        "classification": "Digital Marketing",
        "year": 2022
      },
      {
        "firstname": "Olivia",
        "lastname": "CHOI",
        "presidency": "President 2012-2013",
        "classification": "Tertiary Education - Statistics",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Ricky",
        "lastname": "SHAM",
        "presidency": "",
        "classification": "Manufacturing - Electronic Appliances",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Rita",
        "lastname": "KU",
        "presidency": "",
        "classification": "Solicitor",
        "year": "2022"
      },
      {
        "firstname": "Rosenna",
        "lastname": "MAK",
        "presidency": "President\n2019-2020",
        "classification": "Corporate Advisory - Insolvency & Restructing",
        "year": 2011
      },
      {
        "firstname": "Sharon",
        "lastname": "LAW",
        "presidency": "",
        "classification": "Public Service",
        "year": 2015
      },
      {
        "firstname": "Sharon",
        "lastname": "LIU",
        "presidency": "",
        "classification": "Catering Business",
        "year": 2014
      },
      {
        "firstname": "Shirley",
        "lastname": "TAM",
        "presidency": "President 2014-2015",
        "classification": "Motor Insurance Agent",
        "year": "2009 Charter Member"
      },
      {
        "firstname": "Sylvia",
        "lastname": "CHAN",
        "presidency": "",
        "classification": "Banking",
        "year": "2023"
      },
      {
        "firstname": "Simone",
        "lastname": "KONG",
        "presidency": "President\n2022-2023",
        "classification": "Law Practice - Solicitor",
        "year": 2016
      },
      {
        "firstname": "Vivian",
        "lastname": "CHOI",
        "presidency": "",
        "classification": "Accounting",
        "year": 2011
      },
      {
        "firstname": "Wallace",
        "lastname": "LAW",
        "presidency": "",
        "classification": "Wealth Management",
        "year": 2009
      },
      {
        "firstname": "Winnie",
        "lastname": "CHUNG",
        "presidency": "",
        "classification": "Fast Moving Consumer Goods",
        "year": 2016
      }
    ]
  }
  componentWillMount(){


  }
  render() {


    return (
      <div className="Homepage memberlistPage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">



            <a id="list">
              <Container>
                <div className="AboutUsTitle">
                  Our Members
                </div>
                <div className="AboutUsText left">
                Membership to the club is by invitation only. We hope to bring positive energy to the society. Through our members' diverse life experience and expertise in different professions we aim to optimize such effect. Moreover, fellowship among members is equally important.
<br/><br/>
We recruit members who share the same view --- to serve the community through hands-on participation, while serving the club through various committees and taking up leadership role in club planning and services, at the same time to enjoy the fun and satisfaction in the process.

                </div>
                <Divider hidden />
                <div className="memberlist">
                  <Grid centered>
                  <Grid.Row>
                    <Grid.Column mobile={2} tablet={2} computer={2}>
                      <div className="BoardItemDate">First Name</div>
                    </Grid.Column>
                    <Grid.Column mobile={2} tablet={2} computer={2}>
                      <div className="BoardItemDate">Last Name</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Presidency year</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Classification</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Year Admitted</div>
                    </Grid.Column>
                  </Grid.Row>
                  {this.state.memberlist.map((member,id)=>{
                    return(
                      <Grid.Row>
                        <Grid.Column  mobile={2} tablet={2} computer={2}>
                          <div className="BoardItemTitle">{member.firstname}</div>
                        </Grid.Column>
                        <Grid.Column mobile={2} tablet={2} computer={2}>
                          <div className="BoardItemTitle lastname">{member.lastname}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.presidency}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.classification}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.year}</div>
                        </Grid.Column>
                      </Grid.Row>
                    )
                  })}


                  </Grid>
                </div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default MemberList;
